import { useEffect, useState } from 'react';

const backend_url = process.env.REACT_APP_BACKEND_URL;

// Fetches the logged-in user (incl. their RBAC role) from the backend.
// Returns { name, email, role } once loaded, or null while loading.
export default function useCurrentUser() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken') || 'dev-token';
    fetch(`${backend_url}/api/users/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.ok) setUser(data.user);
      })
      .catch(() => {});
  }, []);

  return user;
}
